import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { CustomAuthGuard } from './shared/services/custom-auth.guard';
import { AuthGuard } from '@michelin/auth';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', canActivate: [CustomAuthGuard, AuthGuard], loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule) },
      { path: 'ppse', canActivate: [CustomAuthGuard, AuthGuard], loadChildren: () => import('./pages/ppse/ppse.module').then((m) => m.PpseModule)},
      { path: 'bs', canActivate: [CustomAuthGuard, AuthGuard], loadChildren: () => import('./pages/bs/bs.module').then((m) => m.BsModule)},
      { path: 'basic', canActivate: [CustomAuthGuard, AuthGuard], loadChildren: () => import('./pages/basic/basic.module').then((m) => m.BasicModule)},
    ]
  },
  { path: 'loggedout', component: LogoutComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
